export const checkURLFormat = (url) => {
  const pattern = /^https:\/\/www\.youtube\.com\/watch\?v=[a-zA-Z0-9_-]+$/;
  return pattern.test(url);
};
